import React from 'react'
import styles from './IconWebPage.module.scss'

export default function IconWebPage() {
    return <div className={styles.root} />
}
